





















import {computed, defineComponent, PropType} from "@nuxtjs/composition-api";
import {ProductCustomAttributes} from "~/modules/GraphQL/types";
const IS_VISIBLE_ON_FRONT = 'PRODUCT_DETAILS_PAGE';

export default defineComponent({
  name: 'CustomAttributes',
  props: {
    customAttributes: {
      type: Array as PropType<ProductCustomAttributes>,
      default: () => [],
    }
  },
  setup(props) {
    return {
      customAttributesList: props.customAttributes
    }
  },
  data() {
    return {
      isVisibleOnFront: IS_VISIBLE_ON_FRONT
    }
  }
});
